<div mat-dialog-title>
  <span>{{ 'Dialog.SessionExpiring.Title' | translate }}</span>
</div>

<mat-dialog-content>
  <p>{{ 'Dialog.SessionExpiring.Text' | translate }}</p>
  <div class="countdown-container">
    <span class="countdown-display">{{ countdownDisplay }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onSignOutNow()">
    {{ 'Dialog.SessionExpiring.SignOutNow' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="onStaySignedIn()">
    {{ 'Dialog.SessionExpiring.StaySignedIn' | translate }}
  </button>
</mat-dialog-actions>
